import { http } from '@/core/api/';
export default {
  async GetResources(keys) {
    const qs = keys.join('&messageCodes=');
    const { data } = await http.get(
      `/api/validationsmessages?messageCodes=${qs}`
    );
    if (data) {
      return data;
    }
    return [];
  },
  async LoadValidationMessages(keys) {
    let messages = await this.GetResources(keys);

    let result = {};

    for (let i = 0; i < messages.length; i++) {
      result[messages[i].id] = messages[i].name;
    }
    //Example Data:
    /** One Object with Properties
     * result["R3085494"] = "Message Content";
     * result["R3085495"] = "Message Content";
     *
     */
    return result;
  },
};
